import ScraperBuilder from './models/ScraperBuilder'
import { createConfigScraper } from '@/api/super'

export default {

  namespaced: true,

  state: {
    builder: new ScraperBuilder()
  },

  mutations: {
    ...ScraperBuilder.mutations()
  },

  actions: {
    createScraper: ({ state }, scraper_id) => new Promise((resolve, reject) => {
      createConfigScraper({
        ...state.builder,
        scraper_id
      }, ({data}) => resolve(data), reject)
    })
  },

  getters: {
    builder: state => state.builder
  }

}